import Button, { ButtonProps } from '@mui/material/Button';
import { styled } from '@mui/material/styles';

const PrimaryBtn = styled(Button)<ButtonProps>(() => ({
  transition: 'all 0.15s ease-in-out',
  borderRadius: '20px',
  height: '43px',
  minWidth: '125px',
  paddingRight: '12px',
}));

const ContactButton = styled(Button)(({ theme }) => ({
  backgroundColor: 'rgb(249, 208, 10)',
  color: '#15183A',
  padding: theme.spacing(1, 4),
  fontWeight: 600,
  borderRadius: '8px',
  '&:hover': {
    backgroundColor: 'transparent',
    border: '1px solid rgb(249, 208, 10)',
    color: 'rgb(249, 208, 10)',
  },
}));

// eslint-disable-next-line import/prefer-default-export
export { PrimaryBtn, ContactButton };
